export const HOME_ID = 'home'
export const PORTFOLIO_ID = 'portfolio'
export const ABOUT_ID = 'about-me'
export const CONTACTS_ID = 'contacts'

export const languages = ['en', 'de']